module.exports = "images/enfants_10.aa368dfc.png";